import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ComparerOffre } from '../../engine/ApiCommunicator'
import {
    ActualisationResultatMaxEmpruntable,
    ConstructionJsonComparerOffre,
    EnregistrerDossier,
    relanceCodeSms,
} from '../../engine/Rules'
import store from '../../engine/store'
import './Button.css'

/**
	Bouton "suivant" de fin de page
	Permet de rediriger facilement vers une autre view avec la variable "targetView"
	Avec la variable "EnrDossier" permet de demander l'envoi du dossier. basé sur le contenu du store REDUX actuel.
	Avec la variable "ComparerOffre" permet de demander l'envoi de la demande de comparaison d'offre. basé sur le contenu du store REDUX actuel.
**/

class Button extends Component {
    handleClick(e) {
        if (this.props.EnrDossier) {
            EnregistrerDossier(this.props.answer)
        } else if (this.props.ComparerOffre) {
            ComparerOffre(
                ConstructionJsonComparerOffre(this.props.answer),
                this.props.answer.tech_token_csrf
            )
        } else if (this.props.ActualiserResultatMaxEmpruntable) {
            ActualisationResultatMaxEmpruntable(this.props.answer)
            window.scrollTo(0, 150)
        } else if (this.props.buttonSMS) {
            relanceCodeSms(this.props.answer)
        } else if (this.props.forcerDureeCredit) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'finance_duree_souhaite',
                    value: this.props.forcerDureeCredit,
                },
            })
        }

        if (this.props.targetView !== undefined) {
            history.push('/tunnelmobile/', {
                targetView: this.props.targetView,
            })
        }
    }
    render() {
        const style = {}
        if (this.props.buttonSMS) {
            style.width = '70%' //70%
            style.marginLeft = '15%'
            style.marginRight = '15%'
            style.backgroundColor= 'transparent'
            style.outline = 'none'
            style.color = 'black'
            style.textDecoration = 'underline'
        }
        var disabled = this.props.disabled ? true : false
        if (disabled) {
            style.backgroundColor = 'transparent' //#DCDCDC
            style.outline = 'none'
            style.color = 'black'

        }

        return (
            <button
                className="button pointer regular-font fade-in"
                disabled={disabled}
                style={style}
                onClick={(e) => this.handleClick(e)}
            >
                {' '}
                {this.props.text}
            </button>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        answer: state.answer,
    }
}

export default connect(mapStateToProps)(Button)
